angular.module('unica_survey.survey_controllers')

.controller('SurveyEditController', function(
	$rootScope, $scope, $state, $stateParams,
	SurveyEditService
) {

	$scope.pageTitle = 'Modifica Survey';

	$rootScope.getSurvey( $stateParams.id );

	$scope.saveSurvey = function() {
		$scope.showLoader();

		var surveyData = angular.copy($rootScope.surveyData);

		SurveyEditService
			.update(surveyData)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {

					$rootScope.surveyData = data;

					$scope.showSuccessMsg('Survey aggiornato con successo!', '');
					//$state.go('app.event.list', { year: $rootScope.year });
				} else {
					$rootScope.manageError(data);
				}
			});

	};

})

;